import { MutationPayload } from './mutation-payload';

export interface DeleteFoundationCommitteeResult {
  deleteCommittee: DeleteCommitteePayload;
}

export interface DeleteCommitteePayload extends MutationPayload {
  _empty?: boolean; // An empty(dummy) field since the keeping the interface empty raises a warning.
}
